@if ($locked()) {
    <div class="cm-own-organizations-filter-container">
        <cm-filter-list>
            <ng-container cm-title> Organization</ng-container>
            <ng-container cm-list>
                <div class="cm-selected-organization-list">
                    @for (organization of $selectedOrganizations(); track organization.state) {
                        @if (!organization.label) {
                            <cm-placeholder class="cm-selected-organization-placeholder" />
                        } @else {
                            <div class="cm-selected-organization cm-selected-organization--locked">
                                <div [matTooltip]="organization.label" class="cm-selected-organization-name">
                                    {{ organization.label }}
                                </div>
                            </div>
                        }
                    }
                </div>
            </ng-container>
        </cm-filter-list>
    </div>
} @else if ($isRadioMode() && $libraryChips().length) {
    <cm-filter-list>
        <ng-container cm-title> Organization</ng-container>
        <ng-container cm-list>
            <div class="cm-library-chip-list">
                @for (chip of $libraryChips(); track chip.key) {
                    <button
                        (click)="onToggleLibraryChip(chip)"
                        class="cm-library-chip"
                        [class.cm-library-chip--selected]="$selectedLibraryChipKey() === chip.key"
                    >
                        <span [matTooltip]="chip.label" class="cm-library-chip-label">{{ chip.label }}</span>
                    </button>
                }
            </div>
        </ng-container>
    </cm-filter-list>
} @else if ($organizationShortcuts().length) {
    <cm-filter-list>
        <ng-container cm-title> Organization</ng-container>
        <ng-container cm-list>
            <div class="cm-organization-shortcut-list">
                @for (shortcut of $organizationShortcuts(); track shortcut.id) {
                    <button
                        (click)="onToggleOrganizationShortcut(shortcut)"
                        class="cm-organization-shortcut-item"
                        [class.cm-organization-shortcut-item--selected]="shortcut.selected"
                    >
                        @if (shortcut.selected) {
                            <i class="fa-solid fa-xmark"></i>
                            <span class="cm-organization-shortcut-label">{{ shortcut.label }}</span>
                        } @else {
                            <span class="cm-organization-shortcut-label">+ Show {{ shortcut.label }}</span>
                        }
                    </button>
                }
            </div>
        </ng-container>
    </cm-filter-list>
} @else if (!$can().read.organization()) {
    <div class="cm-own-organizations-filter-container">
        <cm-filter-list>
            <ng-container cm-title> Organization</ng-container>
            <ng-container cm-list>
                @if ($selectedOrganizations().length) {
                    <div class="cm-selected-organization-list">
                        @for (organization of $selectedOrganizations(); track organization.state) {
                            @if (!organization.label) {
                                <cm-placeholder class="cm-selected-organization-placeholder" />
                            } @else {
                                <div (click)="onRemoveOrganization(organization)" class="cm-selected-organization">
                                    <i class="fa-solid fa-xmark"></i>
                                    <div [matTooltip]="organization.label" class="cm-selected-organization-name">
                                        {{ organization.label }}
                                    </div>
                                </div>
                            }
                        }
                    </div>
                } @else {
                    <a (click)="selectOwnOrganizations()">
                        <div>+ Show own library only</div>
                    </a>
                }
            </ng-container>
        </cm-filter-list>
    </div>
}
